module.exports = __webpack_public_path__ + "static/media/21ECLAC29.5dc1c51a.jpg";